var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.httpLoading),expression:"httpLoading"}],staticClass:"main-daily app-container"},[_c('div',{ref:"mainDaily",staticClass:"main-daily-content"},_vm._l((_vm.newList),function(item,index){return _c('EsProductView',{key:index + Math.random(),attrs:{"item":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }